<template>
  <div>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <validated-input-box
      id="loginFieldTopupVoucher"
      ref="loginField"
      :validation-reg-exp="numberRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_ERROR')"
      :label="this.$i18n.t('COMMON.LOGIN_NUMBER')"
      placeholder="6789123456789"
      name="loginField"
    />
    <validated-input-box
      id="voucherField"
      ref="voucherField"
      :validation-reg-exp="voucherRegex"
      :validation-error-message="$i18n.t('TOPUP_VOUCHER.VOUCHER_ERROR')"
      :label="this.$i18n.t('TOPUP_VOUCHER.VOUCHER')"
      placeholder=""
      name="voucherField"
    />
    <submit-button
      id="topupVouchernSubmitButton"
      :label="this.$i18n.t('COMMON.NEXT')"
      :on-click="submitForm"
    />
  </div>
</template>

<script>
import Regex from '../../constants/regex.json';

const RESP_VALIDATION_ERROR=1;
const RESP_MSISDN_NOT_FOR_TOPUP=2;
const RESP_MAX_LIMIT_REACHED=3;
const RESP_VOUCHER_INVALID=4;
const RESP_VOUCHER_USED=5;
const RESP_SIM_NOT_REGISTERED=6;
const RESP_OTHER_ERROR=9999;

export default {
  name: 'TopUpOnce',
  components: {  },
  data: function() {
    return {
      inProgress: false,

    };
  },
  computed: {
    numberRegex: function() {
      return Regex.NUMBER;
    },
    voucherRegex: function() {
      return Regex.VOUCHER;
    },
  },
  mounted: function() {
    this.$refs.loginField.setFieldValue(this.$store.getters.userDetail.msisdn);
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.loginField.isValidBeforeSubmit()
        && this.$refs.voucherField.isValidBeforeSubmit();
      return isValid;
    },
    submitForm: function() {
      if (this.isFormValid() && !this.inProgress) {
        this.inProgress = true;
        const topupVoucherRequest = {
          msisdn: this.$refs.loginField.getFieldValue(),
          voucher: this.$refs.voucherField.getFieldValue(),
          channel: 1
        };
        this.$http.post('api/topup/voucher', topupVoucherRequest)
          .then( (response) => {
            this.processSuccessfulCallResponse(response.data);
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
          })
          .finally(() => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
      this.$store.commit("setSuccessMessage", this.$i18n.t('TOPUP_VOUCHER.SUCCESS'));
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Success', value: 0, noninteraction: false });
      this.$router.push({name: 'topupVoucherSuccess'});
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_MSISDN_NOT_FOR_TOPUP:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - MSISDN not for topup', value: 0, noninteraction: false });
          break;
        case RESP_MAX_LIMIT_REACHED:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP.ONCE.MSISDN_MAX_LIMIT_REACHED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - max limit reached', value: 0, noninteraction: false });
          break;
        case RESP_VOUCHER_INVALID:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP_VOUCHER.VOUCHER_INVALID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - voucher invalid', value: 0, noninteraction: false });
          break;
        case RESP_VOUCHER_USED:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP_VOUCHER.VOUCHER_USED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - voucher used', value: 0, noninteraction: false });
          break;
        case RESP_SIM_NOT_REGISTERED:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP.ONCE.TOPUP_FORBIDDEN_NOT_REGISTERED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - prepaid not legally registered', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup voucher',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
    },
  },
};
</script>

<style lang="scss" src="../../components/loading/loading.scss">
</style>
